/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SalesRankings {
    'use strict';

    import NounEnum = Meevo.Model.NounEnum;
    import SortDirection = Meevo.Model.SortDirection;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import VerbEnum = Meevo.Model.VerbEnum;
    import TrackingItem = Meevo.Model.TrackingItem;
    import AppointmentBookSettings = Meevo.Model.AppointmentBookSettings;
    import SaleRankFilterTypeEnum = Meevo.Model.SaleRankFilterTypeEnum;

    interface ISalesRankingsController {
        getBusinessSettings: () => void;
        closeContext: () => void;
        criteriaChanged: () => void;
        tableView: () => void;
        exportCSV: () => void;
        compileFilters: () => void;
        changeSorting: (sort: number) => void;
        showClientProfile: ($event: any, id: Guid) => void;
        showEmployeeExpandedList: (id: string) => void;
        openShowAdvanced: (isEmployeeFilter: boolean) => void;
        applyAdvancedSearch: (data: IAdvancedSearchCriteria) => void;
    }

    class SalesRankingsController implements ISalesRankingsController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.common.DataExportService',
            '$translate',
            'meevo.plugins.salesRankings.SalesRankingsService',
            'meevo.components.common.IdentityService',
            'meevo.components.short-cuts.ShortCutsService'
        ];

        protected securityKeys = Meevo.Components.Common.SecurityKeys;

        public dataList: Array<IItem>;
        public exportDataList: Array<IItem>;
        public currentDate: Date = new Date(new Date().setHours(0, 0, 0, 0));
        public isFilterScreen: boolean = true;

        // Criteria
        public filterCriteria: ICriteria = {
            criteria: {
                saleRankFilterType: null,
                startDate: this.currentDate,
                endDate: this.currentDate,
                isPercent: false,
                topCount: 5,
                clientId: null,
                employeeFilterList: null
            },
            sortDirection: SortDirection.Descending,
            sortBy: 'Amount',
            isForExport: false
        };
        public previewCriteria: IPreviewCriteria = {
            showFilter: ShowFilterEnum.All,
            itemFilter: ItemFilterEnum.Services,
            itemsPercentageFilter: ItemsPercentageEnum.Items
        };
        public advancedSearchCriteria: IAdvancedSearchCriteria;

        // Properties for template
        public twoYearsBeforeCurrentDate: Date = new Date(new Date(new Date().getTime() - (2 * 365 * 24 * 60 * 60 * 1000)).setHours(0, 0, 0, 0));
        public appointmentBookSettings: AppointmentBookSettings;
        public canExport: boolean = false;
        public activeSortingClass: boolean = true;
        public showTableColumns: ITableColumnTitle;
        public tableColumnTitle: string;
        public tableColumnTitleProduct: string;
        public tableColumnTitleService: string;
        public tableColumnTitleProductService: string;
        public itemsPercentageEnum = ItemsPercentageEnum;
        public showFilterEnum = ShowFilterEnum;
        public sortDirection = SortDirection;
        public itemFilterEnum = ItemFilterEnum;
        public saleRankDetailType = SaleRankDetailType;
        public currentUserName:string;
        public showAllPersons: boolean = false;
        public selectedClient: any;
        public isFilterAppliedOnce: boolean = false;
        public isEmployeesShown: boolean = false;
        public isRankByHidden: boolean = false;
        public isQuantityHidden: boolean = false;
        public tableColumnTitleRetailToService: string;
        public tableColumnTitleRetailToTotal: string;
        public tableColumnTitleCilentsRebooked: string;
        public tableColumnTitleRebooked: string;
        public twoItems: ItemFilterEnum;

        // Arrays for template
        public dateRangeParams = [
            { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
            { name: 'LABEL_TODAY', status: PresetStatus.Today },
            { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
            { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
            { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
            { name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks },
            { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
            { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
            { name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter },
            { name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter },
            { name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear },
            { name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear }
        ];
        public _showList = [
            {
                id: ShowFilterEnum.All,
                label: 'LABEL_ITEMS'
            },
            {
                id: ShowFilterEnum.ClientsPurchased,
                label: 'LABEL_CLIENTS'
            },
            {
                id: ShowFilterEnum.EmployeesSold,
                label: 'LABEL_EMPLOYEES'
            }
        ];
        public _itemsList = [
            {
                id: ItemFilterEnum.AverageTicket,
                label: 'LABEL_AVERAGE_TICKET'
            },
            {
                id: ItemFilterEnum.GiftCards,
                label: 'LABEL_GIFTCARDS_SALES'
            },
            {
                id: ItemFilterEnum.Memberships,
                label: 'LABEL_MEMBERSHIPS_SALES'
            },
            {
                id: ItemFilterEnum.Packages,
                label: 'LABEL_PACKAGES_SALES'
            },
            {
                id: ItemFilterEnum.Products,
                label: 'LABEL_PRODUCTS_SALES'
            },
            {
                id: ItemFilterEnum.Services,
                label: 'LABEL_SERVICES_SALES'
            },
            {
                id: ItemFilterEnum.ProductsServices,
                label: 'LABEL_PRODUCTS_SERVICES_SALES'
            },
            {
                id: ItemFilterEnum.Rebooking,
                label: 'LABEL_REBOOKING'
            },
            {
                id: ItemFilterEnum.RetailToService,
                label: 'LABEL_RETAIL_TO_SERVICE_PERCENT'
            },
            {
                id: ItemFilterEnum.RetailToTotal,
                label: 'LABEL_RETAIL_TO_TOTAL'
            }
        ];
        public _backupItemsList = angular.copy(this._itemsList);
        public _sortByList = [
            {
                sort: 'Amount',
                label: 'LABEL_AMOUNT_SALES'
            },
            {
                sort: 'Quantity',
                label: 'LABEL_QUANTITY'
            }
        ];
        public _itemsQuantityList = [];
        private shortCutGroup: IShortCutGroup;

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected dataExportService: Meevo.Components.Common.IDataExportService,
            protected $translate: angular.translate.ITranslateService,
            protected salesRankingsService: Meevo.Plugins.SalesRankings.SalesRankingsService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
        ) {
            for (let i = 5; i <= 100; i += 5) {
                this._itemsQuantityList.push(i);
            }

            this.getBusinessSettings();

            this.compileFilters();

            this.currentUserName = this.identityService.current().displayName;

            this.$scope.$watch(() => this.previewCriteria.itemsPercentageFilter, () => {
                this.filterCriteria.criteria.isPercent = this.previewCriteria.itemsPercentageFilter === ItemsPercentageEnum.Percentage;
            });

            this.shortCutGroup = new ShortCutGroup([{
                shortCutName: 'DATA_MAINTENANCE_APPLY',
                callback: () => {
                    this.criteriaChanged();
                }
            }], {groupLevel: Components.ShortCuts.GroupLevels.Plugin});

            this.shortCutsService.activateGroup(this.shortCutGroup);
        }

        // Get business setting for Week start day
        getBusinessSettings(): void {
            this.busyService.start();

            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Tenant/BusinessInfo/Settings`, 'GET', null).then((res) => {
                this.appointmentBookSettings = <AppointmentBookSettings>res.data.appointmentBookSettings;
                this.busyService.stop();
            });
        }

        // Close current tab
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        // Filter List
        criteriaChanged(): void {
            this.twoItems = this.previewCriteria.itemFilter;
            this.filterCriteria.isForExport = false;
            this.busyService.start();
            this.filterCriteria.criteria.clientId = this.selectedClient ? this.selectedClient.id : '';
            let backupSortBy = this.filterCriteria.sortBy;

            this.isEmployeesShown = this.previewCriteria.showFilter === ShowFilterEnum.EmployeesSold
                                    && this.previewCriteria.itemFilter !== ItemFilterEnum.AverageTicket
                                    && this.previewCriteria.itemFilter !== ItemFilterEnum.Rebooking
                                    && this.previewCriteria.itemFilter !== ItemFilterEnum.RetailToService
                                    && this.previewCriteria.itemFilter !== ItemFilterEnum.RetailToTotal;

            if (this.previewCriteria.itemFilter === ItemFilterEnum.AverageTicket
                || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToService
                || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToTotal) {
                this.filterCriteria.sortBy = '';
            }

            this.isQuantityHidden = this.previewCriteria.itemFilter === ItemFilterEnum.RetailToService
                                 || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToTotal
                                 || this.previewCriteria.itemFilter === ItemFilterEnum.Rebooking
                                 || this.previewCriteria.itemFilter === ItemFilterEnum.AverageTicket;

            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SaleRank/Entity/List`, 'POST', this.filterCriteria).then((res: any) => {
                this.dataList = this.salesRankingsService.processItem(res.data, this.previewCriteria);

                this.canExport = this.dataList.length > 0;

                this.isFilterAppliedOnce = true;

                this.filterCriteria.sortBy = backupSortBy;

                this.busyService.stop();
            });

            // Change showing table Columns
            this.tableView();

            // Usage Tracking
            let trackingItem = new TrackingItem(NounEnum.SalesRanking, VerbEnum.SearchButtonClicked, this.filterCriteria, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

        // Manipulation with table columns and titles
        tableView(): void {
            let view = this.salesRankingsService.getTableView(this.previewCriteria);

            this.showTableColumns = view.tableColumns;
            this.tableColumnTitle = view.tableTitle;
            this.tableColumnTitleProduct = view.productTitle;
            this.tableColumnTitleService = view.serviceTitle;
            this.tableColumnTitleProductService = view.productServiceTitle;
            this.tableColumnTitleRetailToService = view.retailToServiceTitle;
            this.tableColumnTitleRetailToTotal = view.retailToTotalTitle;
            this.tableColumnTitleCilentsRebooked = view.clientsRebookedTitle;
            this.tableColumnTitleRebooked = view.rebookedTitle;
        }

        exportCSV(): void {
            if (this.previewCriteria.showFilter === ShowFilterEnum.ClientsPurchased) {
                this.filterCriteria.isForExport = true;
                this.busyService.start();
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SaleRank/Entity/List`, 'POST', this.filterCriteria).then((res: any) => {
                    this.exportDataList = this.salesRankingsService.processItem(res.data, this.previewCriteria);
                    this.buildCSV();
                    this.busyService.stop();
                });
            } else {

                switch (this.filterCriteria.criteria.saleRankFilterType) {

                    case SaleRankFilterTypeEnum.EmployeesSellingMemberships:
                    case SaleRankFilterTypeEnum.EmployeesSellingPackages:
                    case SaleRankFilterTypeEnum.EmployeesSellingProducts:
                    case SaleRankFilterTypeEnum.EmployeesSellingServices:


                        let previewSearchCriteria: IPreviewCriteria,
                            detailSearchCriteria: ICriteria;

                        previewSearchCriteria = angular.copy(this.previewCriteria);
                        previewSearchCriteria.showFilter = ShowFilterEnum.All;

                        detailSearchCriteria = angular.copy(this.filterCriteria);
                        detailSearchCriteria.employeeIdList = [];
                        detailSearchCriteria.criteria.saleRankFilterType = this.salesRankingsService.compileFilterType(previewSearchCriteria);
                        detailSearchCriteria.employeeIdList = this.dataList.map(elem => elem.employeeId);

                        this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SaleRank/Entity/Detail`, 'POST', detailSearchCriteria).then((res: any) => {


                            this.exportDataList = res.data.map(elem => {
                                const item = this.dataList.find(el => el.employeeId === elem.employeeId)

                                elem.displayName = item.displayName;
                                elem.employeeFirstName = item.firstName;
                                elem.employeeLastName = item.lastName;
                                elem.employeeCode = item.employeeCode;
                                if (item.serviceValue) elem.totalValue = item.serviceValue;
                                if (item.productValue) elem.totalValue = item.productValue;
                                if (item.value) elem.totalValue = item.value;
                                if (item.quantity) elem.totalQuantity = item.quantity;

                                return elem
                            });

                            switch (this.filterCriteria.sortBy) {
                                case 'Quantity':
                                    this.exportDataList.sort((a, b) => {

                                        if (a.totalQuantity === b.totalQuantity && a.displayName != b.displayName) {
                                            return a.displayName < b.displayName ? -1 : 1
                                        } else {
                                            return a.totalQuantity > b.totalQuantity ? -1 : 1
                                        }
                                    });
                                    break;
                                case 'Amount':
                                    this.exportDataList.sort((a, b) => {

                                        if (a.totalValue === b.totalValue && a.displayName != b.displayName) {
                                            return a.displayName < b.displayName ? -1 : 1
                                        } else {
                                            return a.totalValue > b.totalValue ? -1 : 1
                                        }
                                    });
                                    break;
                            }

                            this.exportDataList = this.salesRankingsService.processItem(this.exportDataList, this.previewCriteria);

                            this.buildCSV();
                            this.busyService.stop();
                        });

                        break;
                    default:
                        this.filterCriteria.isForExport = false;
                        this.exportDataList = angular.copy(this.dataList);
                        this.buildCSV();
                        break;
                }

            }
        }

        // Export CSV
        buildCSV(): void {
            let csvFile = '',
                currencySymbol = this.salesRankingsService.getCurrencySymbol(),
                showFilterItem,
                isPercentView = this.previewCriteria.itemsPercentageFilter === ItemsPercentageEnum.Percentage ? '%' : '';

            switch (this.filterCriteria.criteria.saleRankFilterType) {
                case SaleRankFilterTypeEnum.ClientsBuyingGiftCards:
                case SaleRankFilterTypeEnum.ClientsBuyingMemberships:
                case SaleRankFilterTypeEnum.ClientsBuyingPackages:
                case SaleRankFilterTypeEnum.ClientsBuyingProducts:
                case SaleRankFilterTypeEnum.ClientsBuyingServices:
                case SaleRankFilterTypeEnum.ClientsBuyingProductsOrServices:
                    showFilterItem = _.findWhere(this._showList, { id: ShowFilterEnum.ClientsPurchased });
                    break;
                case SaleRankFilterTypeEnum.EmployeesSellingGiftCards:
                case SaleRankFilterTypeEnum.EmployeesSellingMemberships:
                case SaleRankFilterTypeEnum.EmployeesSellingPackages:
                case SaleRankFilterTypeEnum.EmployeesSellingProducts:
                case SaleRankFilterTypeEnum.EmployeesSellingServices:
                case SaleRankFilterTypeEnum.EmployeesSellingProductsOrServices:
                case SaleRankFilterTypeEnum.AverageTicket:
                case SaleRankFilterTypeEnum.RetailToService:
                case SaleRankFilterTypeEnum.RetailToTotal:
                case SaleRankFilterTypeEnum.Rebooking:
                    showFilterItem = _.findWhere(this._showList, { id: ShowFilterEnum.EmployeesSold });
                    break;
                default:
                    showFilterItem = _.findWhere(this._showList, { id: ShowFilterEnum.All });
                    break;
            }

            // CSV Header
            csvFile += `Date run,${moment().format('MM/DD/YYYY')}\n`;
            csvFile += `User,${this.currentUserName}\n`;
            csvFile += `Criteria:\n`;
            csvFile += `,Show me:,${this.$translate.instant(showFilterItem.label)}\n`;
            csvFile += `,Rankings items:,`

            switch (this.previewCriteria.itemFilter) {
                case ItemFilterEnum.GiftCards:
                    csvFile += `Gift Cards\n`;
                    break;
                case ItemFilterEnum.Memberships:
                    csvFile += `Memberships\n`;
                    break;
                case ItemFilterEnum.Packages:
                    csvFile += `Packages\n`;
                    break;
                case ItemFilterEnum.Products:
                    csvFile += `Products\n`;
                    break;
                case ItemFilterEnum.Services:
                    csvFile += `Services\n`;
                    break;
                case ItemFilterEnum.ProductsServices:
                    csvFile += `Services + Products\n`;
                    break;
                case ItemFilterEnum.AverageTicket:
                    csvFile += `Average Ticket\n`;
                    break;
                case ItemFilterEnum.RetailToService:
                    csvFile += `Retail to Service %\n`;
                    break;
                case ItemFilterEnum.RetailToTotal:
                    csvFile += `Retail to Total %\n`;
                    break;
                case ItemFilterEnum.Rebooking:
                    csvFile += `Rebooking\n`;
                    break;
            }

            csvFile += `,Start Date:,${moment(this.filterCriteria.criteria.startDate).format('MM/DD/YYYY')}\n`;
            csvFile += `,End Date:,${moment(this.filterCriteria.criteria.endDate).format('MM/DD/YYYY')}\n`;
            if (!this.isRankByHidden) {
                csvFile += `,Based on:,${this.getSortByLabel(this.filterCriteria.sortBy)}\n`;
            }
            csvFile += `,Show:,${this.filterCriteria.criteria.topCount + isPercentView}\n`;

            if(this.advancedSearchCriteria && !_.isEmpty(this.advancedSearchCriteria)) {
                csvFile += `Advanced search criteria:\n`;

                if (this.advancedSearchCriteria.distributor) {
                    csvFile += `,Distributor:,${this.advancedSearchCriteria.distributor.displayName}\n`;
                }
                if (this.advancedSearchCriteria.manufacturer) {
                    csvFile += `,Manufacturer:,${this.advancedSearchCriteria.manufacturer.displayName}\n`;
                }
                if (this.advancedSearchCriteria.productCategory) {
                    csvFile += `,Product Category:,${this.advancedSearchCriteria.productCategory.displayName}\n`;
                }
                if (this.advancedSearchCriteria.productSubCategory) {
                    csvFile += `,Product Sub-category:,${this.advancedSearchCriteria.productSubCategory.displayName}\n`;
                }
                if (this.advancedSearchCriteria.product) {
                    csvFile += `,Product:,${this.advancedSearchCriteria.product.displayName}\n`;
                }
                if (this.advancedSearchCriteria.serviceCategory) {
                    csvFile += `,Service Category:,${this.advancedSearchCriteria.serviceCategory.displayName}\n`;
                }
                if (this.advancedSearchCriteria.serviceSubCategory) {
                    csvFile += `,Service Sub-category:,${this.advancedSearchCriteria.serviceSubCategory.displayName}\n`;
                }
                if (this.advancedSearchCriteria.service) {
                    csvFile += `,Service:,${this.advancedSearchCriteria.service.displayName}\n`;
                }
            }

            // CSV Table Header
            switch (showFilterItem.id) {
                case ShowFilterEnum.EmployeesSold:
                    csvFile += '\nEmployee First Name,Employee Last Name,Employee Code,';

                    switch (this.previewCriteria.itemFilter) {
                        case ItemFilterEnum.Memberships:
                        case ItemFilterEnum.Packages:
                        case ItemFilterEnum.Products:
                        case ItemFilterEnum.Services:
                            csvFile += `Item Name,`;
                            break;
                    }

                    break;
                case ShowFilterEnum.All:
                    csvFile += '\nName,';
                    break;
            }

            if (!this.isQuantityHidden) {
                csvFile += '\Quantity (#),';
            }

            switch (this.previewCriteria.itemFilter) {
                case ItemFilterEnum.GiftCards:
                    csvFile += `Gift Cards (${currencySymbol})`;
                    break;
                case ItemFilterEnum.Memberships:
                    csvFile += `Memberships (${currencySymbol})`;
                    break;
                case ItemFilterEnum.Packages:
                    csvFile += `Packages (${currencySymbol})`;
                    break;
                case ItemFilterEnum.Products:
                    csvFile += `Products (${currencySymbol})`;
                    break;
                case ItemFilterEnum.Services:
                    csvFile += `Services (${currencySymbol})`;
                    break;
                case ItemFilterEnum.ProductsServices:
                    csvFile += `Products (${currencySymbol}),Services (${currencySymbol}),Services + Products (${currencySymbol})`;
                    break;
                case ItemFilterEnum.AverageTicket:
                    csvFile += `Average Ticket(Service + Retail) (${currencySymbol})`;
                    break;
                case ItemFilterEnum.RetailToService:
                    csvFile += `Products (${currencySymbol}),Services (${currencySymbol}),Retail to Service %`;
                    break;
                case ItemFilterEnum.RetailToTotal:
                    csvFile += `Product (${currencySymbol}),Services (${currencySymbol}),Total Amount (${currencySymbol}), Retail to Total %`;
                    break;
                case ItemFilterEnum.Rebooking:
                    csvFile += `Clients Rebooked, Rebooked %`;
                    break;
            }

            if (showFilterItem.id !== ShowFilterEnum.ClientsPurchased) {
                csvFile += `\n`;
            }

            if (showFilterItem.id === ShowFilterEnum.ClientsPurchased) {
                csvFile += ',Numeric Identifier,Prefix,Client First Name,Client Middle Name,Client Last Name,Address 1,Address 2,City,State,ZipCode,HomePhoneNumber,MobilePhoneNumber,ApptNotifOptInState,UseForTextMarketing,WorkPhoneNumber,WorkPhoneExtension,PrimaryPhone Type,Email Address,EmailDeliveryStatus,EmailCommOptedInState,IsMarketingEmailEnabled,FirstVisitDate,LastVisitDate,Gender,BirthYear,BirthMonth,BirthDay,AnniversaryDate,ClientType,IsMinor,IsRestricted,IsTransient,AllowBookingRebookingOnline,ExcludeFromReceivingPoints,AllowChargesCreditOnAccount,IsMember,ReferralType,ReferralTypeDisplayName,ReferralFirstName,ReferralLastName,NoSellSharePersonalInfo\n';
            }

            // CSV Create rows
            let csvDataList = angular.copy(this.exportDataList);
            for (var i = 0; i < csvDataList.length; i++) {
                csvDataList[i].displayName = csvDataList[i].displayName.replace(/,/g, " -")
                csvFile += this.salesRankingsService.processCSVRow(csvDataList[i], this.previewCriteria);
            }

            this.dataExportService.generateFile(csvFile, 'Sales Rankings Export', Meevo.Components.Common.FileTypeEnum.CSV);

            // Usage Tracking
            let trackingItem = new TrackingItem(NounEnum.SalesRanking, VerbEnum.ExportButtonClicked, this.filterCriteria, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

        // Compile Filters
        compileFilters(showFilter?: false): void {
            if (showFilter) {
                this.advancedSearchCriteria = {};
                this.filterCriteria.criteria.advancedFilter = {};
                this.filterCriteria.criteria.clientId = '';
            }

            this._itemsList = this._backupItemsList;

            if (this.previewCriteria.showFilter === ShowFilterEnum.All
                && (this.previewCriteria.itemFilter === ItemFilterEnum.ProductsServices
                    || this.previewCriteria.itemFilter === ItemFilterEnum.Rebooking
                    || this.previewCriteria.itemFilter === ItemFilterEnum.AverageTicket
                    || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToService
                    || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToTotal)
                || ((this.previewCriteria.showFilter === ShowFilterEnum.ClientsPurchased)
                    && (this.previewCriteria.itemFilter === ItemFilterEnum.Rebooking
                        || this.previewCriteria.itemFilter === ItemFilterEnum.AverageTicket
                        || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToService
                        || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToTotal))) {

                this.previewCriteria.itemFilter = ItemFilterEnum.Services;
            }

            if (this.previewCriteria.showFilter === ShowFilterEnum.All) {
                this._itemsList = this._backupItemsList.filter(item => {
                    return item.id !== ItemFilterEnum.ProductsServices
                        && item.id !== ItemFilterEnum.AverageTicket
                        && item.id !== ItemFilterEnum.Rebooking
                        && item.id !== ItemFilterEnum.RetailToService
                        && item.id !== ItemFilterEnum.RetailToTotal
                });
            }

            if (this.previewCriteria.showFilter === ShowFilterEnum.ClientsPurchased) {
                this._itemsList = this._backupItemsList.filter(item => {
                    return item.id !== ItemFilterEnum.AverageTicket
                        && item.id !== ItemFilterEnum.Rebooking
                        && item.id !== ItemFilterEnum.RetailToService
                        && item.id !== ItemFilterEnum.RetailToTotal
                })
            }

            this.showAllPersons = this.previewCriteria.showFilter === ShowFilterEnum.All;
            if (!this.showAllPersons) {
                this.selectedClient = null;
                this.filterCriteria.criteria.clientId = '';
            }

            this.isRankByHidden = this.previewCriteria.itemFilter === ItemFilterEnum.AverageTicket
                                || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToService
                                || this.previewCriteria.itemFilter === ItemFilterEnum.RetailToTotal;

            this.filterCriteria.criteria.saleRankFilterType = this.salesRankingsService.compileFilterType(this.previewCriteria);

            this.toggleBasedOnFilter();
        }

        // Change Sorting
        changeSorting(sort: number): void {
            this.filterCriteria.sortDirection = sort === SortDirection.Ascending ? SortDirection.Ascending : SortDirection.Descending;
            this.activeSortingClass = sort === SortDirection.Descending;

            this.criteriaChanged();
        }

        // Action for open client Profile
        showClientProfile($event: any, id: Guid): void {
            let stateParams = {
                id: id,
                actionState: Model.MaintenanceFormState.Readonly,
                targetState: Model.MaintenanceFormVisualState.Detail
            };

            this.$rootScope.$broadcast('gotoState', {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: stateParams
            });

            $event.stopPropagation();
        }

        // Show Expanded list of items for EmployeeSold
        showEmployeeExpandedList(id: string): void {
            let employeeInfo = this.dataList.find(e => e.employeeId === id),
                previewSearchCriteria: IPreviewCriteria,
                detailSearchCriteria: ICriteria;

            employeeInfo.expandedItemsList = [];

            if (employeeInfo.isExpanded) {
                employeeInfo.isExpanded = false;
            } else {
                employeeInfo.isExpanded = true;

                this.busyService.start();

                previewSearchCriteria = angular.copy(this.previewCriteria);
                previewSearchCriteria.showFilter = ShowFilterEnum.All;

                detailSearchCriteria = angular.copy(this.filterCriteria);
                detailSearchCriteria.employeeIdList = [];
                detailSearchCriteria.criteria.saleRankFilterType = this.salesRankingsService.compileFilterType(previewSearchCriteria);
                detailSearchCriteria.employeeIdList.push(id);

                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SaleRank/Entity/Detail`, 'POST', detailSearchCriteria).then((res: any) => {
                    employeeInfo.expandedItemsList = this.salesRankingsService.detailedItemsList(res.data);

                    this.busyService.stop();
                });
            }
        }

        // Toggle Advanced Search
        openShowAdvanced(isEmployeeFilter: boolean = false): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/salesRankings/advancedSearch.template.html',
                controller: 'meevo.plugins.salesRankings.ModalAdvancedSearchController',
                controllerAs: 'vm',
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    itemFilter: this.previewCriteria.itemFilter,
                    showFilter: this.previewCriteria.showFilter,
                    defaultCriteria: this.advancedSearchCriteria,
                    isEmployeeFilter: isEmployeeFilter,
                    employeesList: this.filterCriteria.criteria.employeeFilterList
                }
            }

            this.modalService.showCustom(options).then((res: any) => {
                this.advancedSearchCriteria = res.criteria || [];
                this.filterCriteria.criteria.employeeFilterList = res.employees || null;

                this.applyAdvancedSearch(res.criteria);
            });
        }

        // Apply Advanced Search
        applyAdvancedSearch(data: IAdvancedSearchCriteria): void {
            if (data) {
                this.filterCriteria.criteria.advancedFilter = {
                    serviceCriteria: {
                        serviceId: data.service && data.service.id,
                        serviceCategoryId: data.serviceCategory && data.serviceCategory.id,
                        serviceSubCategoryId: data.serviceSubCategory && data.serviceSubCategory.id
                    },
                    productCriteria: {
                        productId: data.product && data.product.productId,
                        productCategoryId: data.productCategory && data.productCategory.id,
                        productSubCategoryId: data.productSubCategory && data.productSubCategory.id,
                        manufacturerId: data.manufacturer && data.manufacturer.id,
                        distributorId: data.distributor && data.distributor.id
                    },
                    giftCardCriteria: {
                        giftCardTypeId: data.giftCardType && data.giftCardType.id
                    },
                    membershipCriteria: {
                        membershipTypeId: data.membershipType && data.membershipType.id,
                        membershipId: data.membership && data.membership.id
                    },
                    packageCriteria: {
                        packageId: data.package && data.package.id
                    }
                };
            }

            this.criteriaChanged();
        }

        // Toggle filter (mobile)
        public toggleFilter = () => {
            this.isFilterScreen = !this.isFilterScreen;
        }

        //Toggle Based On filter
        toggleBasedOnFilter(): void {
                this._sortByList = _.map(this._sortByList, (item) => {
                    switch (item.sort) {
                        case 'Amount':
                            item.label = this.previewCriteria.itemFilter === ItemFilterEnum.Rebooking ? 'LABEL_REBOOKED_PERCENT' : 'LABEL_AMOUNT_SALES';
                            break;
                        case 'Quantity':
                            item.label = this.previewCriteria.itemFilter === ItemFilterEnum.Rebooking ? 'LABEL_CLIENTS_REBOOKED' : 'LABEL_QUANTITY';
                            break;
                    }
                    return item;
                });
        }

        getSortByLabel(sortBy: string): string {
            let elem = this._sortByList.find((item: any) => item.sort === sortBy);
            return this.$translate.instant(elem.label);
        }

    }

    angular.module('meevo.plugins.salesRankings')
        .controller('meevo.plugins.salesRankings.SalesRankingsController', SalesRankingsController);
}
